import { ENV } from "../../../env";
import UserAgent from "../../../components/Utils/UserAgent";

export const allowedPaymentOrigin = (origin) => {
    const baseAllowedOrigins = [
        "pagos.mundijuegosdineroreal.com",
        "frontend-qa.sgs.red",
        "frontend-alpha.sgs.red",
    ];
    
    if (ENV === "local") {
        baseAllowedOrigins.push("localhost");
    }
    
    return baseAllowedOrigins.some((allowed) => origin.includes(allowed));
};

export const mustRedirectPayments = () => {
    // Android
    if (UserAgent.isAndroid()) {
        return false;
    }

    // iOS
    if (UserAgent.isIOS()) {
        return false;
    }

    // Browser Chrome
    if (UserAgent.isChrome()) {
        return false;
    }

    // Browser Safari
    if (UserAgent.isSafari()) {
        return false;
    }

    // Browser Firefox
    if (UserAgent.isFirefox()) {
        return false;
    }

    // Browser Internet Explorer
    if (UserAgent.isInternetExplorer()) {
        return false;
    }

    // In-app browser Facebook
    if (UserAgent.isEmbeddedWebView()) {
        return false;
    }

    return true;
};

export const redirect = (url) =>  {
    window.location.href = url;
};
